import React, { useState } from 'react'
import {
    Box, Container, Grid, Stack, Typography, Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
} from '@mui/material'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useResponsive } from '../../../hooks/use-responsive';
import './referAndEarn.css'



export default function FAQ() {
    const mdUp = useResponsive("up", "md");
    const containerData = [
        {
            title: "How does MegaConnect's 'Refer and Earn' program work?",
            description:
                "After signing up with MegaConnect, you'll receive a unique referral code. Share this code, and when someone completes their first payment using it, you get 50% cashback, and they get an instant 50% discount.",
        },
        {
            title: "Where will I receive my cashback reward?",
            description:
                "Your 50% cashback reward will be directly credited to your UPI account once your referral completes their first payment.",
        },
        {
            title: "How many people can I refer?",
            description:
                "There’s no limit! Refer as many people as you like and earn cashback with every successful referral.",
        },
    
        {
            title: "When do I receive my cashback?",
            description:
                "You receive your cashback within 48 hours, once your referred completes their first payment with MegaConnect.",
        },
 
        {
            title: "What happens if my friend doesn’t complete their first payment?",
            description:
                "Cashback rewards are only applied once the referred user completes their first payment using your code.",
        },
        {
            title: "Is there a minimum subscription plan my referral has to choose for me to earn cashback?",
            description:
                "No, all MegaConnect subscription plans are eligible for the referral discount and cashback.",
        },
 
        {
            title: "Can I check the status of my referrals?",
            description:
                "Yes, you can track all referrals and rewards directly in your MegaConnect Dashboard.",
        },
    ];
    


    const [expandedIndex, setExpandedIndex] = useState(null); // Track the expanded accordion index

    const handleAccordionChange = (index) => {
        if (expandedIndex === index) {
            // If the same accordion is clicked, collapse it
            setExpandedIndex(null);
        } else {
            // Expand the new accordion and update the selected image
            setExpandedIndex(index);
        }
    };
    return (
        <Container maxWidth={false} sx={{
            p:{md:'64px 250px' , xs:'28px 20px'},
            backgroundColor: '#F1F1F1',
        }} >

            <Stack direction='column' justifyContent='center' alignItems='center'  >
                <Grid container md={12} justifyContent='center' alignItems='center' textAlign='center' >

                    {mdUp && <Typography  marginBottom={1} className="HeroHeadingNewRNE"
                        textAlign='center' >
                        Frequently Asked
                        <span className='HeroHeadingItalic' style={{ color: '#1E53E8', }} > Questions </span>
                    </Typography>}
                    {!mdUp &&
                        <Typography  marginBottom={1} className="HeroHeadingNewRNE"
                            textAlign='center'  >
                            Frequently Asked
                            <span className='HeroHeadingItalic' style={{ color: '#1E53E8', }} > Questions </span>
                        </Typography>
                    }
                    {mdUp && <Typography  className="heroTextNewRnE" textAlign='center' >
                        Have questions about MegaConnect’s Refer and Earn program? Here’s everything you need to know!
                    </Typography>}
                    {!mdUp && <Typography className="heroTextNewRnE" textAlign='center' >
                        Have questions about MegaConnect’s Refer and Earn program? Here’s everything you need to know!
                    </Typography>}
                </Grid>

                <Box sx={{ mt:{md:'38px',xs:'26px'}}}>
                    {containerData.map((item, index) => (
                        <>
                        <Divider color='3px solid black' />
                        <Accordion
                            key={index}
                            expanded={expandedIndex === index}
                            onChange={() => handleAccordionChange(index)}
                            sx={{
                                mb: 0, // Remove bottom margin
                                boxShadow: 'none', // Remove the default shadow
                                border: 'none', // Remove any default border
                                backgroundColor: '#F1F1F1',
                                // borderTop:  '1px solid black', // Only add top border if not the first item
                                // '&:last-of-type': {
                                //     borderBottom: '1px solid black', // Add bottom border to the last accordion
                                // },
                                // transition: 'border-color 0.3s',
                            }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                <Typography
                                    sx={{
                                        display: "flex",
                                        fontSize: {md:'22px', xs:"18px "},
                                        fontFamily: 'Roboto Flex',
                                        fontStyle: expandedIndex === index ? 'italic' : 'italic',
                                        fontWeight: expandedIndex === index ? 800 : 400,
                                        lineHeight: {md:'33px', xs:'27px'},
                                        color: expandedIndex === index ? "#1D53E7" : "black",
                                    }}

                                >
                                    {item.title}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    // display: "flex",
                                    fontFamily: "Roboto Flex",
                                    justifyContent: "center",
                                    fontSize:  {md:'18px', xs:'16px'},
                                    lineHeight: {md:'27px', xs:'24px'},
                                    fontWeight: 400,
                                }}
                            >
                                {item.description}
                            </AccordionDetails>
                        </Accordion>
                       
                        </>
                    ))}
                      <Divider color='3px solid black' />
                </Box>
            </Stack>


        </Container>
    )
}
